import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { APP_STORE_URL } from "../lib/seo";

const NAV = [
  { to: "/ai-virtual-try-on", label: "AI Virtual Try-On" },
  { to: "/ai-stylist", label: "AI Stylist" },
  { to: "/digital-closet", label: "Digital Closet" },
  { to: "/spotted-a-look", label: "Spotted a Look" },
  { to: "/shop-and-try", label: "Shop & Try" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/faq", label: "FAQ" },
];

export const SiteNav = () => {
  const [open, setOpen] = useState(false);
  useLocation(); // re-render on route change
  const item = (n) =>
    n.hash ? (
      <a key={n.to} href={n.to} onClick={() => setOpen(false)} data-testid={`nav-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{n.label}</a>
    ) : (
      <Link key={n.to} to={n.to} onClick={() => setOpen(false)} data-testid={`nav-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{n.label}</Link>
    );
  return (
    <nav data-testid="site-nav">
      <div className="wrap row">
        <Link className="brand" to="/" data-testid="nav-brand">
          <img src="/logo.png" alt="C-STYL logo" />
          <span>C-STYL</span>
        </Link>
        <div className="links">
          <span className="deskonly">{NAV.map(item)}</span>
          <a className="btn" href="/#get" data-testid="nav-get-cstyl">Get C-STYL</a>
          <button className="nav-toggle" aria-label="Menu" aria-expanded={open} onClick={() => setOpen((o) => !o)} data-testid="nav-toggle">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              {open ? <path d="M6 6l12 12M18 6L6 18" /> : <><path d="M3 6h18" /><path d="M3 12h18" /><path d="M3 18h18" /></>}
            </svg>
          </button>
        </div>
      </div>
      <div className={"drawer" + (open ? " open" : "")} data-testid="nav-drawer">{NAV.map(item)}</div>
    </nav>
  );
};

const FOOTER_LINKS = [
  { to: "/ai-virtual-try-on", label: "AI Virtual Try-On" },
  { to: "/ai-stylist", label: "AI Stylist" },
  { to: "/digital-closet", label: "Digital Closet" },
  { to: "/spotted-a-look", label: "Spotted a Look" },
  { to: "/shop-and-try", label: "Shop & Try" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/faq", label: "FAQ" },
  { to: "/launch", label: "Launch Film" },
  { to: "/support", label: "Support" },
  { to: "/privacy", label: "Privacy" },
  { to: "/terms", label: "Terms" },
];

export const SiteFooter = () => (
  <footer data-testid="site-footer">
    <div className="wrap">
      <div className="row">
        <Link className="brand" to="/" data-testid="footer-brand">
          <img src="/logo.png" alt="C-STYL logo" />
          <span>C-STYL</span>
        </Link>
        <div className="flinks">
          {FOOTER_LINKS.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{l.label}</Link>
          ))}
          <a href="mailto:support@c-styl.com" data-testid="footer-contact">Contact</a>
        </div>
      </div>
      <div className="cr">© 2026 C-STYL. Your AI personal stylist, digital closet and virtual try-on companion. All rights reserved.</div>
    </div>
  </footer>
);
